import { theme } from "../styles/theme";

function TabsBar({ tabActiva, setTabActiva, tabsPermitidos }) {
  const labels = {
    tabla: "Registros",
    stats2: "Tutores/Evaluadores",
    tablas: "Filtros",
    temarios: "Temas y Temarios"
  };
  const tabs = tabsPermitidos || ["tabla", "stats2", "tablas", "temarios"];

  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px", flexWrap: "wrap" }}>
      {tabs.map((tab) => (
        <div
          key={tab}
          onClick={() => setTabActiva(tab)}
          style={{
            padding: "10px 15px",
            borderRadius: "8px",
            cursor: "pointer",
            background: tabActiva === tab ? theme.colors.primary : theme.colors.panelBg,
            color: tabActiva === tab ? "#fff" : theme.colors.text,
            border: `1px solid ${tabActiva === tab ? theme.colors.primary : theme.colors.border}`,
            boxShadow: tabActiva === tab ? "0 10px 20px rgba(19, 59, 104, 0.18)" : "none",
            fontWeight: 600
          }}
        >
          {labels[tab]}
        </div>
      ))}
    </div>
  );
}

export default TabsBar;
